module.exports = __webpack_public_path__ + "assets/media/level-06.47231349.png";